import { styled } from '@mui/material/styles';
import { Box, Card, Skeleton } from '@mui/material';

const CardWrapper = styled(Card)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    borderRadius: '12px',

    '& .color-section': {
        padding: '16px 18px',
        background: theme.palette.backgroundBar.main,
    },

    '& .top-section': {
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '12px',
        gap: '8px',
    },

    '& .content-section': {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },

    '& .action-section': {
        padding: '18px',
        height: '100%',
        display: 'flex',
        gap: '12px',
        borderLeft: '1px solid rgba(255, 255, 255, 0.10)',
        borderRight: '1px solid rgba(255, 255, 255, 0.10)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.10)',
        borderBottomLeftRadius: '12px',
        borderBottomRightRadius: '12px',
    },

    '& .action-wrapper': {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: '12px',
    },

    '& .action-item': {
        padding: '8px 12px',
        backgroundColor: 'rgba(45, 47, 49, 1)',
        borderRadius: '8px',
        minWidth: '132px',
        height: '48px',
    },
}));

const JobOfferCardSkeleton = () => {
    return (
        <CardWrapper>
            <Box className="color-section">
                <Box className="top-section">
                    {/* Top section with assignee info */}
                    <Box sx={{ flex: 1 }}>
                        <Skeleton variant="text" width="60%" height={16} sx={{ mb: 0.5 }} />
                        <Skeleton variant="text" width="80%" height={16} />
                    </Box>
                    <Skeleton variant="text" width={8} height={16} />
                    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                        <Skeleton variant="text" width="70%" height={16} sx={{ mb: 0.5 }} />
                        <Box sx={{ display: 'flex', gap: '4px' }}>
                            <Skeleton variant="circular" width={16} height={16} />
                            <Skeleton variant="circular" width={16} height={16} />
                            <Skeleton variant="circular" width={16} height={16} />
                        </Box>
                    </Box>
                </Box>

                <Box className="content-section">
                    {/* Company info */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', mb: 1 }}>
                        <Skeleton variant="circular" width={17} height={17} />
                        <Skeleton variant="text" width="40%" height={16} />
                    </Box>

                    {/* Job title */}
                    <Skeleton variant="text" width="80%" height={20} sx={{ mb: 1 }} />

                    {/* Job number */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', mb: 1 }}>
                        <Skeleton variant="text" width="30%" height={14} />
                        <Skeleton variant="rectangular" width={10} height={12} />
                    </Box>

                    {/* Details (location and contract type) */}
                    <Box sx={{ display: 'flex', gap: '40px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <Skeleton variant="rectangular" width={12} height={12} />
                            <Skeleton variant="text" width="60px" height={14} />
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <Skeleton variant="rectangular" width={12} height={12} />
                            <Skeleton variant="text" width="50px" height={14} />
                        </Box>
                    </Box>
                </Box>
            </Box>

            <Box className="action-section">
                <Box className="action-wrapper">
                    {/* Page visits */}
                    <Box className="action-item">
                        <Skeleton variant="text" width="60%" height={16} sx={{ mb: 0.5 }} />
                        <Skeleton variant="text" width="80%" height={14} />
                    </Box>

                    {/* Salary range */}
                    <Box className="action-item">
                        <Skeleton variant="text" width="70%" height={16} sx={{ mb: 0.5 }} />
                        <Skeleton variant="text" width="60%" height={14} />
                    </Box>
                </Box>

                <Box className="action-wrapper">
                    {/* Hiring process */}
                    <Box className="action-item">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', mb: 0.5 }}>
                            <Skeleton variant="circular" width={16} height={14} />
                            <Skeleton variant="circular" width={16} height={14} />
                            <Skeleton variant="circular" width={16} height={14} />
                        </Box>
                        <Skeleton variant="text" width="90%" height={14} />
                    </Box>

                    {/* Duration */}
                    <Box className="action-item">
                        <Skeleton variant="text" width="50%" height={16} sx={{ mb: 0.5 }} />
                        <Skeleton variant="text" width="40%" height={14} />
                    </Box>
                </Box>
            </Box>
        </CardWrapper>
    );
};

export default JobOfferCardSkeleton;
